<template>
  <v-card width="100%" elevation="2" class="vc-card-patient-schedule pa-0">
    <!-- <div class="vc-scheduling-card-header pa-2">
      <v-icon size="24px" color="white">mdi-calendar</v-icon>
      <div class="white--text vc-font-16 ml-2">
        {{ schedule.date }} - {{ day }}
      </div>
    </div> -->

    <div class="vc-scheduling-card-header pa-2">
      <v-icon size="24px" color="white">mdi-calendar</v-icon>
      <div class="white--text vc-font-16 ml-2">
        {{ formattedDate }}
      </div>
    </div>

    <div
      class="vc-scheduling-card-body vc-column-center vc-w-100 pt-8 pb-8 pl-3 pr-3"
    >
      <v-row class="vc-w-100 ma-0 vc-row-center vc-scheduling-card-body-info">
        <v-col
          cols="12"
          sm="12"
          md="4"
          lg="4"
          xl="4"
          class="pa-2 vc-column-center"
        >
          <v-icon size="60px" color="primary">mdi-account-circle</v-icon>
          <div class="vc-text-bold">
            {{ schedule.doctor.people.name }}
          </div>
          <v-alert
            v-if="
              currentCompany.show_alert_by_doctor_for_patient &&
              schedule.doctor.company_doctor_unic.observations
            "
            color="warning"
            dense
            text
            type="warning"
            class="text-center"
          >
            <strong>{{
              schedule.doctor.company_doctor_unic.observations
            }}</strong>
          </v-alert>
        </v-col>
        <v-col cols="12" sm="12" md="8" lg="8" xl="8" class="pa-2">
          <div class="text-center mb-1">Selecione o horário desejado:</div>
          <center>
            <v-alert
              v-if="
                schedule && schedule.free_time && schedule.free_time.length < 1
              "
              color="info"
              dense
              text
              type="info"
              class="text-center"
              style="width: 60%"
            >
              <p>Não há horário disponível</p>
            </v-alert>
          </center>
          <v-row
            v-if="currentCompany.schedule_time_group && schedule && schedule.free_time && schedule.free_time.length > 0"
            class="vc-w-100 ma-0 d-flex bg-danger"
          >
            <v-col cols="12" >
              <!-- <v-btn @click="reserveSchedule(schedule.start_time)" block>
                {{ schedule.start_time + ' - ' + schedule.end_time }}
              </v-btn> -->

              <v-btn
                block
                v-if="
                  currentCompany.show_alert_by_doctor_for_patient &&
                  schedule.doctor.company_doctor_unic.observations
                "
                @click="
                  alert(time, schedule.doctor.company_doctor_unic.observations)
                "
              >
                {{ schedule.start_time + ' - ' + schedule.end_time }}
              </v-btn>
              <v-btn v-else @click="reserveSchedule(schedule.start_time)" block>
                {{ schedule.start_time + ' - ' + schedule.end_time }}
              </v-btn>
            </v-col>
            <v-col cols="12" align="center">
              <small class="text-center mb-2"
                >Atenção: o atendimento será realizado por ordem de
                chegada</small
              >
            </v-col>
          </v-row>
          <v-row v-else class="vc-w-100 ma-0 d-flex">
            <v-col
              v-for="(time, i) in schedule.free_time"
              :key="`${i}${time}`"
              class="px-2 pt-2 pb-2"
            >
              <v-btn
                v-if="
                  currentCompany.show_alert_by_doctor_for_patient &&
                  schedule.doctor.company_doctor_unic.observations
                "
                @click="
                  alert(time, schedule.doctor.company_doctor_unic.observations)
                "
              >
                {{ time }}
              </v-btn>
              <v-btn v-else @click="reserveSchedule(time)">
                {{ time }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import ls from 'local-storage';
import moment from 'moment';
import 'moment/locale/pt-br';

moment.locale('pt-br');

export default {
  name: 'card-schedule',
  props: {
    schedule: { type: Object, default: () => {} },
  },
  data: () => ({
    resp: '',
    timeSelected: '',
    day: '',
    weekDays: {
      0: {
        name: 'Domingo',
      },
      1: {
        name: 'Segunda-feira',
      },
      2: {
        name: 'Terça-feira',
      },
      3: {
        name: 'Quarta-feira',
      },
      4: {
        name: 'Quinta-feira',
      },
      5: {
        name: 'Sexta-feira',
      },
      6: {
        name: 'Sábado',
      },
    },
  }),
  computed: {
    formattedDate() {
      if (!this.schedule?.date) return '';
      return moment(this.schedule.date, 'DD/MM/YYYY').format(
        'DD/MM/YYYY - dddd',
      );
      // return moment(this.schedule.date).format('DD/MM/YYYY - dddd');
    },
    currentCompany() {
      return this.$store.getters.currentCompany;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let dateIndex = this.schedule.date;
      dateIndex = this.reverseDateStringTwo(dateIndex);
      dateIndex = this.replaceDateStringTwo(dateIndex);
      dateIndex = new Date(dateIndex);
      dateIndex = dateIndex.getUTCDay();
      this.day = this.weekDays[dateIndex].name;
    },
    checkProceduresOnline(data, time) {
      let health_insurance = ls.get('currentConvenant');
      console.log(health_insurance);
      this.$store
        .dispatch('checkProceduresOnline', {
          company_id: this.currentCompany.id,
          doctor_id: this.schedule.doctor_id,
          health_insurance_id: health_insurance.health_insurance_id,
        })
        .then((resp) => {
          ls.set('onlineProcedures', resp);
          if (this.currentCompany.schedule_time_group) {
            this.setSchedule(data);
          } else {
            this.setSchedule(time);
          }
        });
    },

    async alert(time, observation) {
      await this.$swal
        .fire({
          title: 'Atenção',
          text: observation,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim, confirmar',
          cancelButtonText: 'Cancelar',
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.reserveSchedule(time);
            console.log(this.resp, 'resp');
            if (!this.resp) {
              this.$swal.fire({
                title: 'Complete o cadastro!',
                text: 'Horário selecionado, agora complete o cadastro para concluir seu agendamento.',
                showConfirmButton: true,
                icon: 'success',
                // timer: 2000,
              });
            } else {
              this.$swal.fire({
                title: 'Erro!',
                text: 'Horário já reservado.',
                showConfirmButton: false,
                icon: 'error',
                timer: 2000,
              });
            }
          }
          this.resp = '';
        });
    },
    async reserveSchedule(time) {
      await this.$store
        .dispatch('reserveSchedule', {
          schedule_id: this.schedule.id,
          time: time,
          group: this.currentCompany.schedule_time_group,
        })
        .then((resp) => {
          this.$store.commit('SET_NOTIFICATION', {
            type: 'success',
            message: 'Horário reservado com sucesso!',
          });
          this.checkProceduresOnline(resp.time, time);
        })
        .catch((error) => {
          var messageError = '';
          switch (error.response.data.message) {
            case 'time taken':
              messageError = 'Horário já Preenchido!';
              break;
            case 'all time taken':
              messageError = 'Intervalo de Horário Lotado!';
              break;
            default:
              messageError =
                'Não foi possivél realizar agendamento, horário não está mais disponivel!';
          }
          this.resp = messageError;
          this.$store.commit('SET_NOTIFICATION', {
            type: 'danger',
            message: messageError,
          });
        });
    },
    setSchedule(time) {
      let doctor = {
        doctor_id: this.schedule.doctor_id,
        name_doctor: this.schedule.doctor.people.name,
      };
      ls.set('currentDoctor', doctor);
      this.$store.commit('SET_CURRENT_DOCTOR', doctor);
      this.$emit('setSchedule', {
        schedule: this.schedule,
        time: time,
        date: this.schedule.date,
      });
    },
  },
};
</script>
